import type { UserTrade } from '@/lib/api/speed';

export function isActionableActiveTrade(trade: UserTrade): boolean {
    return trade.closeTxHash === null || trade.closeTxHash === undefined;
}

/**
 * The user's live trade for `coin`, or null. `pairBase` is stored lowercased
 * while the coin the UI works in is upper/mixed case, so the match is
 * case-insensitive. Pending trades are excluded: there is no position yet, so
 * there are no resting triggers to read or edit.
 *
 * One resolver for every consumer — the trigger editor and the chart drew the
 * same position's TP from different places once, and disagreed about it.
 */
export function findOpenTrade(
    trades: UserTrade[] | undefined,
    coin: string | null,
): UserTrade | null {
    if (!trades || !coin) return null;
    const wanted = coin.toLowerCase();
    return (
        trades.find(
            (trade) =>
                trade.status === 'Open' &&
                trade.pairBase.toLowerCase() === wanted,
        ) ?? null
    );
}
